/* import __COLOCATED_TEMPLATE__ from './add-website-sheet.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import { action } from '@ember/object';
import Component from '@glimmer/component';

interface Signature {
  Args: {
    model: {
      open?: boolean;
      appId: string;
      adminId: string;
      onClose: () => void;
      onSubmit: () => void;
    };
    options?: any;
  };
}

export default class AddWebsiteSheet extends Component<Signature> {
  @action
  onClose() {
    this.args.model.onClose();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::KnowledgeHub::AddContent::AddWebsite::AddWebsiteSheet': typeof AddWebsiteSheet;
    'react/knowledge-hub/add-content/add-website/add-website-sheet': typeof AddWebsiteSheet;
  }
}
